// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2SCpq","colLarge":"styles_colLarge__1AshW","col":"styles_col__18aKP","colCheckbox":"styles_colCheckbox__37oaJ","actions":"styles_actions__c3RTg"};